import {
  DashboardTimeRangeOptionType,
  IDashboardPageBootcampProgress,
  IDashboardPageLastPlayed,
  IDashboardPageNotesPlayed,
  IDashboardPageNotesPlayedTimeRange,
  IDashboardPagePlayingTime,
  IDashboardPagePlayingTimeRange, IDashboardPageRecentlyPlayed, IDashboardPageSongsProgress, IDashboardPageUserSummary
} from "./IDashboardPageStore";
import {dashboardPageSlice, IDashboardLoadPayload} from "./dashboardPageSlice";
import {store} from "../../../redux/store";

const loadingStatusAsDone = [
  "completed",
  "error",
];

export const dashboardStore = {
  // State modifiers
  clearDashboardPage: () => {
    store.dispatch(dashboardPageSlice.actions.clearDashboardPageReducer());
  },
  loadDashboardPage: (payload: IDashboardLoadPayload) => {
    store.dispatch(dashboardPageSlice.actions.loadDashboardPageReducer(payload));
  },
  setDisplayDashboardInfoModal: (isVisible: boolean) => {
    store.dispatch(dashboardPageSlice.actions.isInfoModalVisibleReducer(isVisible));
  },
  setNotesPlayedRange: (selectedRange: DashboardTimeRangeOptionType) => {
    store.dispatch(dashboardPageSlice.actions.notesPlayedRangeReducer(selectedRange));
  },
  setPlayingTimeRange: (selectedRange: DashboardTimeRangeOptionType) => {
    store.dispatch(dashboardPageSlice.actions.playingTimeRangeReducer(selectedRange));
  },
  setRequestStatus: (status: "loading" | "error" | "completed") => {
    store.dispatch(dashboardPageSlice.actions.requestStatusReducer(status));
  },

  // Getters
  getBootcampProgress: (): IDashboardPageBootcampProgress => { return dashboardPageSlice.selectors.bootcampProgressSelector(store.getState()) ?? {} as IDashboardPageBootcampProgress; },
  getIsReady: (): boolean => { return loadingStatusAsDone.includes(dashboardStore.getRequestStatus() ?? 'not-started'); },
  getLastPlayed: (): IDashboardPageLastPlayed => { return dashboardPageSlice.selectors.lastPlayedSelector(store.getState()) ?? {} as IDashboardPageLastPlayed; },
  getNotesPlayed: (): IDashboardPageNotesPlayed => { return dashboardPageSlice.selectors.notesPlayedSelector(store.getState()) ?? {} as IDashboardPageNotesPlayed; },
  getNotesPlayedSelectedRange: (): DashboardTimeRangeOptionType => { return dashboardStore.getNotesPlayed()?.selectedRange ?? "allTime"; },
  getNotesPlayedByRangeData: (selectedRange: DashboardTimeRangeOptionType): IDashboardPageNotesPlayedTimeRange => { return dashboardStore.getNotesPlayed()?.byRange?.[selectedRange] ?? {} as IDashboardPageNotesPlayedTimeRange; },
  getNotesPlayedBySelectedRangeData: (): IDashboardPageNotesPlayedTimeRange => { return dashboardStore.getNotesPlayedByRangeData(dashboardStore.getNotesPlayedSelectedRange()); },
  getPlayingTime: (): IDashboardPagePlayingTime => { return dashboardPageSlice.selectors.playingTimeSelector(store.getState()) ?? {} as IDashboardPagePlayingTime; },
  getPlayingTimeSelectedRange: (): DashboardTimeRangeOptionType => { return dashboardStore.getPlayingTime()?.selectedRange ?? "allTime"; },
  getPlayingTimeSelectedRangeData: (): IDashboardPagePlayingTimeRange => { return dashboardStore.getPlayingTimeRangeData(dashboardStore.getPlayingTimeSelectedRange()) as IDashboardPagePlayingTimeRange; },
  getPlayingTimeRangeData: (selectedRange: DashboardTimeRangeOptionType): IDashboardPagePlayingTimeRange => { return dashboardStore.getPlayingTime()?.byRange?.[selectedRange] ?? {} as IDashboardPagePlayingTimeRange; },
  getRecentlyPlayed: (): IDashboardPageRecentlyPlayed => { return dashboardPageSlice.selectors.recentlyPlayedSelector(store.getState()) ?? {lessons: []} as IDashboardPageRecentlyPlayed; },
  getRequestStatus: (): ReduxStoreRequestStatusValueType | undefined => { return dashboardPageSlice.selectors.requestStatusSelector(store.getState()); },
  getSongsProgress: (): IDashboardPageSongsProgress => { return store.getState().dashboardPage.songsProgress ?? {} as IDashboardPageSongsProgress; },
  getUserSummary: (): IDashboardPageUserSummary => { return dashboardPageSlice.selectors.userSummarySelector(store.getState()) ?? {} as IDashboardPageUserSummary; },
}